import getLocalTrigger from "../../../utils/get-local-trigger";
import setWindowScroll from "../../../utils/set-window-scroll";
import WINDOW from "../../../utils/window";
import run from "../../animate/run";
import initInview from "../utils/init-inview";

/**
 * Scroll
 * @param {CustomEventProps} event
 */
const scroll = (event) => {
  setWindowScroll();

  const windowHeight = /** @type {Number} */ (WINDOW.get("height"));
  const scroll = /** @type {WindowCoordinatesProps} */ (WINDOW.get("scroll"));
  const scrollY = /** @type {Number} */ (scroll.get("y"));
  const scrollX = /** @type {Number} */ (scroll.get("x"));

  const triggers = /** @type {Map<MainClassProps, Array<String>>} */ (
    getLocalTrigger("scroll")
  );

  initInview(windowHeight, scrollX, scrollY);

  if (!triggers) {
    return;
  }

  const lastRafY = /** @type {Number} */ (scroll.get("last-raf-y"));
  const deltaY = scrollY - lastRafY;

  scroll.set("delta-y", deltaY);

  for (const [item, array] of triggers) {
    const main = item;

    for (const name of array) {
      const trigger = /** @type {TriggerProps} */ (main.store.get(name));
      const active = trigger.get("is-active");
      // console.log(trigger.get("per"));
      if (!active) {
        run(event, "enter", true, trigger, main);
      }
    }
  }
};

export default scroll;
